var map = {
	"./assessment-icon.svg": "./src/assets/img/prepare-home/assessment-icon.svg",
	"./available-training-courses.svg": "./src/assets/img/prepare-home/available-training-courses.svg",
	"./business-icon.svg": "./src/assets/img/prepare-home/business-icon.svg",
	"./businesscase-pop.svg": "./src/assets/img/prepare-home/businesscase-pop.svg",
	"./chk-white.svg": "./src/assets/img/prepare-home/chk-white.svg",
	"./close-popup.svg": "./src/assets/img/prepare-home/close-popup.svg",
	"./congrats-bg.gif": "./src/assets/img/prepare-home/congrats-bg.gif",
	"./digital-organization.svg": "./src/assets/img/prepare-home/digital-organization.svg",
	"./disable-cursor.svg": "./src/assets/img/prepare-home/disable-cursor.svg",
	"./factory-future.svg": "./src/assets/img/prepare-home/factory-future.svg",
	"./intro-course.svg": "./src/assets/img/prepare-home/intro-course.svg",
	"./logistic-intro-course.svg": "./src/assets/img/prepare-home/logistic-intro-course.svg",
	"./loss-icon.svg": "./src/assets/img/prepare-home/loss-icon.svg",
	"./measure.svg": "./src/assets/img/prepare-home/measure.svg",
	"./my-trainging-h1-.svg": "./src/assets/img/prepare-home/my-trainging-h1-.svg",
	"./my-trainging-h1.svg": "./src/assets/img/prepare-home/my-trainging-h1.svg",
	"./plant-flag.jpg": "./src/assets/img/prepare-home/plant-flag.jpg",
	"./plant-flag.svg": "./src/assets/img/prepare-home/plant-flag.svg",
	"./prepare-execute.svg": "./src/assets/img/prepare-home/prepare-execute.svg",
	"./resource-card-img.svg": "./src/assets/img/prepare-home/resource-card-img.svg",
	"./search-icon.svg": "./src/assets/img/prepare-home/search-icon.svg",
	"./tech-adoption-icon.svg": "./src/assets/img/prepare-home/tech-adoption-icon.svg",
	"./training-course.svg": "./src/assets/img/prepare-home/training-course.svg",
	"./unitar-banner-home.svg": "./src/assets/img/prepare-home/unitar-banner-home.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/prepare-home sync recursive ^\\.\\/.*$";